import React from 'react'
import { Achievement } from '../../Api'
import { BarCon, LevelsCon, PrizeCon } from './styles'
import { LevelItem } from './LevelItem'
import { Bar } from '../Bar/Bar'
import { colors } from '../consts'

type MultiLevelProps = {
  achievement: Achievement
  link?: string
}

export const MultiLevelProgress: React.FC<MultiLevelProps> = ({ achievement }) => {
  const maxProgress =
    achievement.successMetricArr[achievement.successMetricArr.length - 1].successMetric
  let completed =
    achievement.status === 'COMPLETE' || achievement.userProgress >= maxProgress
  const getFilledWidth = (userProg: number) => {
    if (userProg >= maxProgress) {
      return maxProgress
    }
    if (userProg < achievement.successMetricArr[0].successMetric) {
      return 0
    }
    if (userProg < achievement.successMetricArr[1].successMetric) {
      return userProg - 2500
    }
    if (userProg < achievement.successMetricArr[2].successMetric) {
      return userProg - 2500
    }
    return userProg
  }

  const filledWidth = getFilledWidth(achievement.userProgress)

  return (
    <>
      <BarCon>
        <Bar
          side="right"
          fillColor={colors.yellow}
          filledWidth={filledWidth}
          totalWidth={maxProgress}
        />
      </BarCon>
      <LevelsCon>
        {achievement.successMetricArr.map((lev) => (
          <LevelItem
            key={lev.metricId}
            level={lev}
            userProg={completed ? lev.successMetric : achievement.userProgress}
            isComplete={achievement.status === 'COMPLETE'}
          />
        ))}
      </LevelsCon>
      {achievement?.levelRewards && achievement.levelRewards.length > 0 && (
        <PrizeCon>
          {achievement.levelRewards.map((reward) => (
            <div className="prizeItem" key={reward.title}>
              {!reward.img && <p>{reward.desc}</p>}
              {reward.img && <img src={reward.img} alt={reward.title} />}
            </div>
          ))}
        </PrizeCon>
      )}
    </>
  )
}
